// client/src/pages/Weddings/steps/DessertsStep/components/SelectedSummary.jsx
import React from "react";
import { Box, Stack, Typography, Chip } from "@mui/material";

export default function SelectedSummary({
  selections,
  selectedGroups,
  subtotal,
}) {
  return (
    <Box sx={{ mt: 2.5 }}>
      <Stack spacing={1.25} alignItems="stretch">
        {selectedGroups.length > 0 && (
          <Box
            sx={{
              p: 1.25,
              border: "1px solid",
              borderColor: "divider",
              borderRadius: 2,
              bgcolor: (t) => t.palette.background.paper,
            }}>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              sx={{ mb: 0.5 }}>
              <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                Selected
              </Typography>
              <Chip
                size="small"
                label={`${selections.reduce(
                  (s, d) => s + (Number(d.quantity) || 0),
                  0
                )} pcs`}
                sx={{
                  height: 22,
                  "& .MuiChip-label": { px: 0.75, fontSize: 12 },
                }}
              />
            </Stack>

            <Stack spacing={0.75}>
              {selectedGroups.map((g) => (
                <Stack key={g.key} spacing={0.25}>
                  <Typography
                    variant="caption"
                    sx={{ fontWeight: 700, opacity: 0.8 }}>
                    {g.label}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {g.rows.map((r) => `${r.name} ×${r.qty}`).join(", ")}
                  </Typography>
                </Stack>
              ))}
            </Stack>
          </Box>
        )}

        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
            Desserts subtotal: ${subtotal.toFixed(2)}
          </Typography>
        </Box>
      </Stack>
    </Box>
  );
}
